define('presentation/common/callDetails/presentationObjects/callDetailsReceptionistMessagePresentationObject',[],function() {
    return function(){
        const self = this;

        self.receptionistMessageId = null;
        self.scriptName = null;
        self.interactionType = null;
        self.employeeName = null;
        self.formName = null;
        self.formResponses = [];
        self.isJunk = false;
        self.junkStatus = null;
        self.participantName = null;
        self.participantEmailAddress = null;
        self.domain = null;
        self.webChatTranscript = [];
        self.canSeeFormResponses = false;
        self.subscriberIds = ko.observableArray([]);
        self.recipients = [];
    };
});

